module.exports = __webpack_public_path__ + "client/projects/assets/youtube-auto-like/yal-material-liker.png";


//////////////////
// WEBPACK FOOTER
// ./client/projects/assets/youtube-auto-like/yal-material-liker.png
// module id = 297
// module chunks = 0